import React from "react";
import product1 from "../assets/Product1.webp";
import product2 from "../assets/Product2.webp";

const Features = ({ theme }) => {
  const sectionBg = theme === "dark" ? "bg-[#0e1521]" : "bg-gray-50";
  const cardBg = theme === "dark" ? "bg-[#1e2b3a] text-white" : "bg-white text-black";

  return (
    <section id="features" className={`${sectionBg} w-full py-16 px-4`}>
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-10">Product Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-base">
          {["📍 GPS Tracking", "⚠️ AI Driving Alerts", "📈 Performance Analytics", "🛠 Maintenance Reminders", "🚛 Dispatch Management", "🎥 Dashcam Integration"].map((feature, idx) => (
            <div key={idx} className={`${cardBg} p-4 rounded shadow hover:scale-105 transition-transform duration-300`}>{feature}</div>
          ))}
        </div>
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          <img src={product1} alt="Dashcam" className="h-28 rounded shadow hover:scale-110 transition-transform" />
          <img src={product2} alt="OBD Device" className="h-28 rounded shadow hover:scale-110 transition-transform" />
        </div>
      </div>
    </section>
  );
};

export default Features;